export const renderMultiMatrixCellText = (field, played) => {
	if (isNaN(played) || played === null) {
		return null
	}

	if (field === 'ev') {
		const positiveSign = played.toFixed(4) > 0 ? '+' : ''

		return positiveSign + (played * 100).toFixed(2)
	}

	if (field === 'eq' || field === 'eqr') {
		return `${parseFloat((played * 100).toFixed(0))}%`
	}

	return `${(played * 100).toFixed(0)}%`
}

export const getCellTextStyleSettings = (isStrategy, isOnePlayer, mapper, key) => {
	if (mapper === 'substrateHeight') {
		const substrateHeight = {
			0: isStrategy ? '40%' : '80%',
			1: isStrategy ? '50%' : '90%',
			2: isStrategy ? '56%' : '94%',
		}

		return substrateHeight[key]
	}
	if (mapper === 'substrateY') {
		const substrateY = {
			0: isStrategy ? '28%' : '10%',
			1: isStrategy ? '25%' : '6%',
			2: isStrategy ? '20%' : '4%',
		}

		return substrateY[key]
	}
	if (mapper === 'lineHeight') {
		const lineHeight = {
			0: isStrategy ? '20px' : '24px',
			1: isStrategy ? '24px' : '27px',
			2: isStrategy ? '26px' : '29px',
		}

		return lineHeight[key]
	}
	if (mapper === 'fontSize') {
		const fontSize = {
			0: isOnePlayer ? '18px' : '26px',
			1: isOnePlayer ? 'x-large' : '32px',
			2: isOnePlayer ? 'xx-large' : '36px',
		}

		return fontSize[key]
	}

	if (mapper === 'fontSizePercent') {
		const fontSizePercent = {
			0: isOnePlayer ? '14px' : '20px',
			1: isOnePlayer ? '16px' : '28px',
			2: isOnePlayer ? '18px' : '32px',
		}

		return fontSizePercent[key]
	}
}
